import { CatalogTab, CompanyDetailTab } from './pages/AdminPages';

export type AdminRouteId = 'home' | 'users' | 'companies' | 'imports' | 'catalog' | 'delivery-zones' | 'orders' | 'files' | 'file-contexts' | 'queues';

export interface AdminNavItem {
  route: AdminRouteId;
  path: string;
  label: string;
}

export const ADMIN_HOME_PATH = '/admin';
export const ADMIN_USERS_PATH = '/admin/users';
export const ADMIN_COMPANIES_PATH = '/admin/companies';
export const ADMIN_IMPORTS_PATH = '/admin/imports';
export const ADMIN_CATALOG_PATH = '/admin/catalog';
export const ADMIN_DELIVERY_ZONES_PATH = '/admin/delivery-zones';
export const ADMIN_ORDERS_PATH = '/admin/orders';
export const ADMIN_DELIVERY_MAP_GENERATIONS_PATH = `${ADMIN_DELIVERY_ZONES_PATH}/generations`;
export const ADMIN_DELIVERY_ZONE_LIVE_MAP_PATH = `${ADMIN_DELIVERY_ZONES_PATH}/live-map`;
export const ADMIN_FILES_PATH = '/admin/diagnostics/files';
export const ADMIN_QUEUES_PATH = '/admin/diagnostics/queues';

export const adminNavigation: AdminNavItem[] = [
  { route: 'home', path: ADMIN_HOME_PATH, label: 'Главная' },
  { route: 'users', path: ADMIN_USERS_PATH, label: 'Пользователи' },
  { route: 'companies', path: ADMIN_COMPANIES_PATH, label: 'Компании' },
  { route: 'orders', path: ADMIN_ORDERS_PATH, label: 'Заказы' },
  { route: 'imports', path: ADMIN_IMPORTS_PATH, label: 'Импорт' },
  { route: 'catalog', path: ADMIN_CATALOG_PATH, label: 'Каталог' },
  { route: 'delivery-zones', path: ADMIN_DELIVERY_ZONES_PATH, label: 'Зоны' },
  { route: 'files', path: ADMIN_FILES_PATH, label: 'Файлы' },
  { route: 'file-contexts', path: '/admin/file-contexts', label: 'Контексты файлов' },
  { route: 'queues', path: ADMIN_QUEUES_PATH, label: 'Очереди' },
];

export function getAdminUserDetailPath(userId: number): string {
  return `${ADMIN_USERS_PATH}/${userId}`;
}

export function getAdminCompanyDetailPath(companyId: number, tab?: CompanyDetailTab): string {
  if (tab === undefined || tab === 'info') {
    return `${ADMIN_COMPANIES_PATH}/${companyId}`;
  }

  return `${ADMIN_COMPANIES_PATH}/${companyId}/${tab}`;
}

export function getAdminCompanyDeliveryAddressCreatePath(companyId: number): string {
  return `${ADMIN_COMPANIES_PATH}/${companyId}/delivery-addresses/new`;
}

export function getAdminCompanyDeliveryAddressEditPath(companyId: number, addressId: number): string {
  return `${ADMIN_COMPANIES_PATH}/${companyId}/delivery-addresses/${addressId}/edit`;
}

export function getAdminCompanyDeliveryZoneCreatePath(companyId: number): string {
  return `${ADMIN_COMPANIES_PATH}/${companyId}/delivery-zones/new`;
}

export function getAdminCompanyDeliveryZoneEditPath(companyId: number, groupId: number): string {
  return `${ADMIN_COMPANIES_PATH}/${companyId}/delivery-zones/${groupId}/edit`;
}

export function getAdminCatalogPath(tab?: CatalogTab): string {
  if (tab === undefined) {
    return ADMIN_CATALOG_PATH;
  }

  return `${ADMIN_CATALOG_PATH}/${tab}`;
}

export function getAdminCatalogProductDetailPath(productId: number): string {
  return `${ADMIN_CATALOG_PATH}/products/${productId}`;
}

export function getAdminImportDetailPath(importId: number): string {
  return `${ADMIN_IMPORTS_PATH}/${importId}`;
}

export function isAdminNavItemActive(item: AdminNavItem, pathname: string): boolean {
  if (item.path === ADMIN_HOME_PATH) {
    return pathname === ADMIN_HOME_PATH;
  }

  return pathname === item.path || pathname.startsWith(`${item.path}/`);
}

export function normalizeCatalogTab(value: string | undefined): CatalogTab {
  if (value === 'offers') return 'products';
  if (value === 'showcase' || value === 'categories' || value === 'products') {
    return value;
  }

  return 'showcase';
}

export function normalizeCompanyDetailTab(value: string | undefined): CompanyDetailTab {
  if (value === 'users' || value === 'chats' || value === 'files' || value === 'delivery-addresses' || value === 'delivery-zones' || value === 'prices' || value === 'offers') {
    return value;
  }

  return 'info';
}

export const ADMIN_CATALOG_PRODUCT_CREATE_PATH = `${ADMIN_CATALOG_PATH}/products/new`;
export const ADMIN_CATALOG_CATEGORY_CREATE_PATH = `${ADMIN_CATALOG_PATH}/categories/new`;

export function getAdminCatalogProductEditPath(productId: number): string {
  return `${ADMIN_CATALOG_PATH}/products/${productId}/edit`;
}

export function getAdminCatalogCategoryEditPath(categoryId: number): string {
  return `${ADMIN_CATALOG_PATH}/categories/${categoryId}/edit`;
}

export function getAdminCatalogCategoryDetailPath(categoryId: number): string {
  return `${ADMIN_CATALOG_PATH}/categories/${categoryId}`;
}
